import { SAN_FRANCISCO_HUB_PATH_IDENTIFIER } from '@/lib/constants';
import { hubStore } from '@/models/stores/hubs';
import { useParams } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

const DEFAULT_HUB_PATH_IDENTIFIER = SAN_FRANCISCO_HUB_PATH_IDENTIFIER;

const isValidHubPath = (hubPath: string | undefined): boolean => {
  if (!hubPath) return false;
  const knownPaths = hubStore.allHubPathIds;
  // If the store hasn't hydrated yet, accept any non-empty string
  if (knownPaths.length === 0) return true;
  return knownPaths.includes(hubPath);
};

const useHub = () => {
  const { hub: hubPathIdentifier } = useParams({ strict: false });
  const [lastHubPathIdentifier, setLastHubPathIdentifier] = useState<string>(
    () => {
      if (!isValidHubPath(hubPathIdentifier as string)) {
        return DEFAULT_HUB_PATH_IDENTIFIER;
      }

      return hubPathIdentifier as string;
    },
  );

  useEffect(() => {
    if (!isValidHubPath(hubPathIdentifier as string)) {
      return;
    }

    setLastHubPathIdentifier(hubPathIdentifier as string);
  }, [hubPathIdentifier]);

  return { hubPathIdentifier, lastHubPathIdentifier };
};

export default useHub;
